import styled from 'styled-components';
export const NavContainer = styled.nav `
  position: sticky;
  top: 0;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 1rem 10%;
  border-bottom: 1px solid #f3f4f6;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
//   max-width: 1400px;
//   margin: 0 auto;

  @media (max-width: 768px) {
    padding: 1rem;
    justify-content: space-between;
  }
`;
export const LogoContainer = styled.div `
  display: flex;
  align-items: center;
`;
export const LogoLink = styled.a `
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: opacity 0.3s;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  img {
    height: 60px;
    width: auto;
    display: block;
  }

  @media (max-width: 768px) {
    img {
      height: 32px;
    }
  }
`;
export const HamburgerButton = styled.button `
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  z-index: 101;

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
export const HamburgerIcon = styled.div `
  width: 24px;
  height: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  span {
    display: block;
    height: 3px;
    width: 100%;
    background: #1a1a1a;
    border-radius: 2px;
    transition: all 0.3s ease;
    transform-origin: center;
  }

  ${(props) => props.$isOpen
    ? `
    span:nth-child(1) {
      transform: translateY(8.5px) rotate(45deg);
    }
    span:nth-child(2) {
      opacity: 0;
      transform: translateX(-10px);
    }
    span:nth-child(3) {
      transform: translateY(-8.5px) rotate(-45deg);
    }
  `
    : ''}
`;
export const NavList = styled.ul `
  display: flex;
  justify-content: center;
  list-style: none;
  gap: 2rem;
  margin: 0;
  padding: 0;

  @media (max-width: 768px) {
    display: none;
  }
`;
export const MobileNavList = styled.ul `
  display: none;
  list-style: none;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid #f3f4f6;
  flex-direction: column;
  gap: 0;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;

  ${(props) => props.$isOpen
    ? `
    max-height: 400px;
    padding: 1rem 0;
  `
    : ''}

  @media (max-width: 768px) {
    display: flex;
  }

  li {
    width: 100%;
  }

  a {
    display: block;
    padding: 1rem 2rem;
    text-align: left;
    width: 100%;
    border-bottom: 1px solid #f3f4f6;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: #f9fafb;
    }
  }
`;
export const NavLink = styled.a `
  text-decoration: none;
  color: #1a1a1a;
  font-weight: 500;
  position: relative;
  transition: color 0.3s;
  cursor: pointer;

  &:hover {
    color: #ffd700;
  }

  ${(props) => props.$active &&
    `
    color: #ffd700;

    &::after {
      content: '';
      position: absolute;
      bottom: -4px;
      left: 0;
      width: 100%;
      height: 2px;
      background: #ffd700;
    }
  `}
`;
